import React, { ReactNode } from 'react';
import classNames from 'classnames';
import StreamPreviewItemPoster from '../StreamPreviewItemPoster';

import styles from './index.module.scss';

interface StreamPreviewItemContentProps {
  title: string;
  link?: string;
  description?: string;
  posterIcon?: ReactNode;
}

const StreamPreviewItemContent = (props: StreamPreviewItemContentProps) => {
  const { link, title, description, posterIcon } = props;

  return (
    <div className={styles.StreamPreviewItemContent}>
      <div className={styles.StreamPreviewItemContentPosterContainer}>
        <StreamPreviewItemPoster
          title={title}
          link={link}
        />
        {posterIcon}
      </div>

      <div className={styles.StreamPreviewItemContentTextContainer}>
        <h4
          className={classNames(styles.StreamPreviewItemContentTextContainerTitle, {
            [styles.StreamPreviewItemContentTextContainerTitleLong]: !description,
          })}>
          {title}
        </h4>
        {description && <p className={styles.StreamPreviewItemContentTextContainerDescription}>{description}</p>}
      </div>
    </div>
  );
};

export default StreamPreviewItemContent;
